// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewReservation-titleText-seHux {
	font-size: 24px;
	line-height: 32px;
	margin: 0;
}

.ViewReservation-secondaryTextColor-L5O67 {
	color: var(--muted-text-color);
}

.ViewReservation-viewReservationTooltip-OjtMJ {
	position: relative;
	top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/ViewReservation/ViewReservation.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,QAAQ;AACT","sourcesContent":[".titleText {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tmargin: 0;\n}\n\n.secondaryTextColor {\n\tcolor: var(--muted-text-color);\n}\n\n.viewReservationTooltip {\n\tposition: relative;\n\ttop: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": `ViewReservation-titleText-seHux`,
	"secondaryTextColor": `ViewReservation-secondaryTextColor-L5O67`,
	"viewReservationTooltip": `ViewReservation-viewReservationTooltip-OjtMJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
